import { render, staticRenderFns } from "./CreateOrUpdateTypology.vue?vue&type=template&id=627e6bee&scoped=true&"
import script from "./CreateOrUpdateTypology.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateTypology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e6bee",
  null
  
)

export default component.exports